import * as React from "react";
import { Select } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { getLocalTimezone, selectTimezoneMode, setValue } from "../../../../store/timezoneSlice";

interface Props {
  hideLabel?: boolean;
}

export const TimezoneDisplay: React.FC<Props> = ({ hideLabel = false }) => {
  const dispatch = useAppDispatch();
  const mode = useAppSelector(selectTimezoneMode);
  const localTzName = getLocalTimezone();

  return (
    <div
      className="user-menu-date-format"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {hideLabel ? null : <span>Timezone</span>}
      <Select
        value={mode}
        onChange={(value) => dispatch(setValue(value))}
        options={[
          { label: `Local (${localTzName})`, value: "local" },
          { label: "UTC", value: "UTC" },
        ]}
        style={{ width: 300 }}
        popupMatchSelectWidth={false}
        getPopupContainer={(trigger) => trigger.parentElement || document.body}
      />
    </div>
  );
};
